import { WebPlugin } from '@capacitor/core';

import type { ZebraPDAPlugin } from './definitions';

export class ZebraPDAWeb extends WebPlugin implements ZebraPDAPlugin {
  async openReader(): Promise<{ isSuccess: boolean }> {
    throw new Error('Method not implemented.');
  }
  async closeReader(): Promise<{ isSuccess: boolean }> {
    throw new Error('Method not implemented.');
  }
  async disconnect(): Promise<{ isSuccess: boolean }> {
    throw new Error('Method not implemented.');
  }
  async disposeReaders(): Promise<{ isSuccess: boolean }> {
    throw new Error('Method not implemented.');
  }

  async initRFID(): Promise<{ isSuccess: boolean }> {
    console.log("进入web.ts中执行初始化");
    return { isSuccess: false }
  };
}
